import React from "react";
import "./ContactUs.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const ContactUs = () => {
  return (
    <div className="contactus-page">
      {/* Hero */}
      <section className="contactus-hero">
        <h1>Contact Us</h1>
        <p>We’d love to hear from you. Get in touch with us anytime.</p>
      </section>

      {/* Info Cards */}
      <section className="contactus-info">
        <div className="contactus-card">
          <FaPhoneAlt className="contactus-icon" />
          <h3>Call Us</h3>
          <p>+91 876 256 7644</p>
        </div>
        <div className="contactus-card">
          <FaEnvelope className="contactus-icon" />
          <h3>Email</h3>
          <p>sales@miniandjone.com</p>
        </div>
        <div className="contactus-card">
          <FaMapMarkerAlt className="contactus-icon" />
          <h3>Visit Us</h3>
          <p>#234, 6th Main, Behind Vidyapeeta Gururaja Layout, Banashankari 3rd stage Bangalore 560028 , Karnataka, INDIA</p>
        </div>
      </section>

      {/* Form + Map */}
      <section className="contactus-form-section">
        <div className="contactus-form">
          <h2>Get In Touch</h2>
          <form>
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
            <textarea placeholder="Your Message" rows="5" required></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div>

          <div className="contactus-map">
            <iframe
              title="location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.123456789012!2d77.5460000000!3d12.9315000000!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae8f3e21c12345%3A0xabcd1234ef567890!2sBanashankari%203rd%20Stage%2C%20Bengaluru%2C%20Karnataka%2C%20India!5e0!3m2!1sen!2sin!4v169XYZ!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

      </section>
    </div>
  );
};

export default ContactUs;
